<div class="home-container">
    <frg-cards class="agenda" *ngIf="canAccessDonneesMedicales" title="Rendez-vous du jour" [subtitle]="todayDate" subtitleColor="var(--grey3)"
        [fullIcon]="fullIconAgenda" (activatedFull)="routeTo('agenda')">
        <div class="content-card-format">
            <frg-agenda-event *ngIf="resource" [ressource]="resource"></frg-agenda-event>
        </div>
    </frg-cards>
    <frg-cards *ngIf="listAlarms && canAccessDonneesMedicales" class="alarm" title="Mémos patients (alarmes) à venir"
        [border]="listAlarms.objects.length > 0 ? true : false" [fullIcon]="fullIconAlarm"
        (activatedFull)="routeTo('alarm')">
        <div class="content-card-format">
            <div class="alarms-body" *ngFor="let alarm of listAlarms.objects">
                <div class="alarms-infos">
                    <div *ngIf="listAlarms.objects.length > 0" class="icon-notification-container">
                        <frg-inline-svg *ngIf="!alarm.read" fill="var(--grey2)" stroke="none" class="icon-notification"
                            src="assets/icons/bell-no.svg" (click)="disabledAlarm(alarm)">
                        </frg-inline-svg>
                        <!-- <frg-inline-svg *ngIf="alarm.read" fill="var(--orange)" stroke="none" class="icon-notification"
                            src="assets/icons/notification.svg">
                        </frg-inline-svg> -->
                    </div>
                    <div class="infos-alarm-event" (dblclick)="redirectToPatient(alarm)">
                        <p><span>{{ alarm.patientName.split(" ", 2).join(' ') }}</span> ({{ alarm.patientName.split("
                            ")[2] |
                            date:
                            'dd/MM/yyyy'}})</p>
                        <p class="description"
                            [ngStyle]="alarm.read ? {'color': 'var(--orange)'} : {'color': 'var(--grey2)'}">{{
                            alarm.alarme
                            }}</p>
                    </div>
                </div>
            </div>
            <p class="no-data" *ngIf="listAlarms.objects.length === 0">Aucune alarme à afficher</p>
        </div>
    </frg-cards>
    <frg-cards *ngIf="listMemos && canAccessDonneesMedicales" class="memo" [border]="listMemos.objects.length > 0 ? true : false" title="Mémo du cabinet"
        [emptyIcon]="emptyIconMemo" [fullIcon]="fullIconMemo" (activatedFull)="openMemo()"
        (activatedEmpty)="routeTo('memo')">
        <div class="content-card-format">
            <div class="memo-content" *ngFor="let memo of listMemos.objects">
                <div class="infos-memo" (click)="openMemoEdit(memo)">
                    <p>{{ memo.creationDate | date: 'dd/MM/yyyy'}}</p>
                    <p>{{ memo.message }}</p>
                </div>
            </div>
            <p class="no-data" *ngIf="listMemos.objects.length === 0">Aucun mémo à afficher</p>
        </div>
    </frg-cards>
    <frg-card-no-scroll class="news" title="HyperMed News" subtitle="L'actualité de votre logiciel"
        subtitleColor="var(--primary)" color="var(--primary)"
        (activated)="redirectToHypermedNews()">
        <iframe title="HyperMed News" width="100%" height="100%" src="https://news.hypermed.fr"></iframe>
    </frg-card-no-scroll>
</div>

<!-- ========================== -->
<!--  TEMPLATE: SNACK TEMPO     -->
<!-- ========================== -->
<ng-template #CourrierSnackTemplate>
  <div class="snack-tempo-container">
    <span class="snack-message" style="font-size: 12px">Certains documents présents en pièce jointe de vos courriers n'ont pas été ouverts.</span>
    <span class="snack-actions">
      <button mat-stroked-button color="primary" (click)="snackRef.dismiss()">Consulter</button>
      <button mat-icon-button (click)="snackRef.dismissWithAction()">
        <mat-icon>close</mat-icon>
      </button>
    </span>

  </div>

  <mat-progress-bar mode="determinate" [value]="snackProgressValue" class="snack-progress-bar"></mat-progress-bar>
</ng-template>
